/**
 * Phase 1 Public Discovery — internal funnel tracking (PII-lean).
 * Whitelisted event names only (server enforces). Anonymous visitors
 * are correlated via a random localStorage session id — no cookies,
 * no fingerprinting, no third parties. Fire-and-forget by design.
 */
import { apiClient } from "../api/client";

const SID_KEY = "da_sid";

export function funnelSessionId() {
  try {
    let sid = localStorage.getItem(SID_KEY);
    if (!sid) {
      sid =
        (window.crypto && window.crypto.randomUUID && window.crypto.randomUUID()) ||
        `s_${Date.now()}_${Math.random().toString(36).slice(2, 12)}`;
      localStorage.setItem(SID_KEY, sid);
    }
    return sid;
  } catch {
    return "s_anonymous";
  }
}

export function trackFunnel(name, props = {}) {
  try {
    apiClient
      .post("/events/funnel", {
        session_id: funnelSessionId(),
        events: [{ name, props }],
      })
      .catch(() => {});
  } catch {
    /* analytics must never break the UI */
  }
}
